'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'starship';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e039';
var svgPathData = 'M0 112C0 85.5 21.5 64 48 64l160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-46.8 0 47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64 554 64 640 150 640 256S554 448 448 448c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2-47.6 34.6 46.8 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 448c-26.5 0-48-21.5-48-48s21.5-48 48-48l58.8 0 56.2-40.9-21.5-2.9C115.5 304.6 96 282.3 96 256s19.5-48.6 45.5-52.2l21.5-2.9-56.2-40.9-58.8 0c-26.5 0-48-21.5-48-48zM48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 96zm97.9 139.5C135.6 236.9 128 245.7 128 256s7.6 19.1 17.9 20.5l113.5 15.5c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9L145.9 235.5zM32 400c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zm416 16a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarship = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;